import PropTypes from 'prop-types';
import { ReactComponent as Loader } from '../Images/loader.svg';
import './FormControls.css';

function OButton({
  className,
  text,
  disabled,
  isLoading,
  onClick,
  startIcon,
  endIcon,
  style,
  title,
}) {
  let defaultText = !isLoading ? (
    <span>{text}</span>
  ) : (
    <Loader className="spinner" />
  );

  if (startIcon) {
    defaultText = !isLoading ? (
      <div className="o-btn-content">
        {/* {startIcon} <span style={{ marginLeft: '10px' }}>{text}</span> */}
        {startIcon} {text && <span style={{ marginLeft: '10px' }}>{text}</span>}
      </div>
    ) : (
      <div className="o-btn-content">
        <Loader className="spinner" />
        <span style={{ marginLeft: '10px' }}>{text}</span>
      </div>
    );
  }
  if (endIcon) {
    defaultText = !isLoading ? (
      <div className="o-btn-content">
        <span style={{ marginRight: '10px' }}>{text}</span> {endIcon}
      </div>
    ) : (
      <div className="o-btn-content">
        <span style={{ marginRight: '10px' }}>{text}</span>{' '}
        <Loader className="spinner" />
      </div>
    );
  }

  return (
    <button
      type="button"
      className={className || 'o-btn'}
      onClick={onClick}
      disabled={disabled}
      style={style}
      title={title}
    >
      {defaultText}
    </button>
  );
}

export default OButton;

OButton.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  startIcon: PropTypes.element,
  endIcon: PropTypes.element,
  style: PropTypes.object,
};
